<footer class="w-100">
  @if (links) {
    <div class="d-flex justify-content-between w-100 px-4">
      @if (links.privacyPolicy) {
        <div>
          <a [href]="links.privacyPolicy" target="_blank">Privacy</a>
        </div>
      }
      @if (links.cancellationPolicy) {
        <div>
          <a [href]="links.cancellationPolicy" target="_blank">Cancellation Policy</a>
        </div>
      }
      @if (links.contactUs) {
        <div>
          <a [href]="links.contactUs" target="_blank">Contact Us</a>
        </div>
      }
    </div>
  }
</footer>


